<script setup lang="ts">
  import { useWindowSize } from '@vueuse/core'
  import { computed, ref, watchEffect } from 'vue'
  import { useRoute } from 'vue-router'
  import { fmt } from '@/functions'

  const route = useRoute()
  const { width } = useWindowSize()
  const pagination = defineModel<Pagination>()

  const to = (hlm?: number) => {
    return { ...route, query: { ...route.query, hlm } }
  }

  const currentPage = computed(() => pagination.value?.current_page ?? 1)
  const lastPage = computed(() => pagination.value?.last_page ?? 1)

  const pagesLength = computed(() => {
    if (width.value >= 1280) {
      return 21
    } else if (width.value >= 1024) {
      return 15
    } if (width.value >= 640) {
      return 9
    } else {
      return 5
    }
  })
  const pages = ref<number[]>([])
  watchEffect(() => {
    const result = [currentPage.value]
    let offset = 1
    while (result.length < pagesLength.value && offset < pagesLength.value) {
      if (currentPage.value - offset >= 1) {
        result.unshift(currentPage.value - offset)
      }
      if (currentPage.value + offset <= lastPage.value) {
        result.push(currentPage.value + offset)
      }
      offset++
    }

    pages.value = result
  })
</script>

<template>
  <nav
    v-if="pagination && lastPage > 1"
    role="navigation"
    aria-label="Pagination Navigation">
    <div class="my-4 flex items-center justify-end sm:justify-between space-x-4">
      <div class="text-xs max-sm:hidden">
        Menampilkan
        <span class="font-semibold">{{ fmt.number(pagination.from) }}-{{ fmt.number(pagination.to) }}</span>
        dari
        <span class="font-semibold">{{ fmt.number(pagination.total) }}</span>
      </div>
      <div class="pagination">
        <router-link
          v-if="currentPage > 2"
          :to="to(1)">
          &laquo;
        </router-link>
        <router-link
          v-for="page in pages"
          :key="page"
          :to="to(page)"
          :class="{
            'active': page === currentPage,
          }">
          {{ fmt.number(page) }}
        </router-link>
        <router-link
          v-if="lastPage - currentPage > 1"
          :to="to(lastPage)">
          &raquo;
        </router-link>
      </div>
    </div>
  </nav>
</template>

<style lang="postcss" scoped>
.pagination {
  @apply flex gap-1;

  a {
    @apply rounded size-8 flex-center border text-sm bg-white;
  }
  a.active {
    @apply bg-primary-500 text-white border-transparent;
  }
}
</style>
